<template>
  <v-textarea
   class="descriptionText"
    v-if="!isInternetExplorer"
    :outlined="!disabled"
    :filled="disabled"
    :value="value"
    :hide-details="'auto'"
    full-width
    :label="label"
    :hint="hint"
    :rows="params.rows"
    :rules="rules"
    :disabled="disabled"
    @input="emitValue"
  >
    <template v-if="$slots.required" v-slot:prepend-inner>
      <slot name="required"></slot>
    </template>
  </v-textarea>

  <!-- Componenet for IE problems wit even @input -->
  <v-textarea
    v-else
    :outlined="!disabled"
    :filled="disabled"
    :value="value"
    :hide-details="'auto'"
    full-width
    auto-grow
    no-resize
    :label="label"
    :hint="hint"
    :rows="params.rows"
    :rules="rules"
    :disabled="disabled"
    @change="emitValue"
  >
    <template v-if="$slots.required" v-slot:prepend-inner>
      <slot name="required"></slot>
    </template>
  </v-textarea>

</template>

<script>
export default {
  props: {
    label: String,
    hint: String,
    placeholder: String,
    rows: String,
    disabled: Boolean,
    initialValue: {
      required: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    params: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },
  data({ initialValue }) {
    return {
      value: initialValue,
      throttle: null,
      isInternetExplorer: (navigator.userAgent.indexOf('Trident/') > -1),
    };
  },
  created() {
    if (this.initialValue != null) {
      this.$emit('update:inputData', {
        value: this.initialValue,
      });
    }
    this.throttle = this.$throttle((value) => {
      this.$emit('update:inputData', { value });
    }, 200);
  },
  methods: {
    getValue(val) {
      return typeof this.params.value === 'function' ? this.params.value({ value: val }) : val;
    },
    emitValue(value) {
      this.value = value;
      this.throttle(value);
    },
  },
  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>

<style scoped>
.descriptionText :first-child :nth-child(3) :first-child{
  overflow: inherit !important;
  text-overflow: initial !important;
  white-space: normal !important;
}
</style>
